export const PAID_CONTENT_LABEL = '付费资讯';
